import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Input from '@mui/material/Input';
import * as magdalaAPI from '../../actions/magdala';
import FormWrapper from '../common/form/FormWrapper';
import Form from '../common/form/Form';
import FormField from '../common/form/FormField';
import PopMessage from '../common/messages/PopMessage';
import stateConfig from '../../config/state';
import urls from '../../config/urls';
import validator from '../../utils/validator';
import { random } from '../../utils/utils';

function CommunityRegistration({ communities, magdalaAPI }) {
  const navigate = useNavigate();

  const [submission, setSubmission] = useState(false);
  const [communityName, setCommunityName] = useState('');
  const [requestId, setRequestId] = useState(null);
  const [formError, setFormError] = useState(null);
  const [communitiesError, setCommunitiesError] = useState(null);

  useEffect(() => {
    const community = communities.byId[`${stateConfig.keys.MAGDALA_COMM}.${requestId}`];

    if(submission && communities.ids && community) {
      if(community.error) {
        setSubmission(false);
        setCommunitiesError(community.error);
      } else {
        navigate(`${urls.magdalaCommunityManage}?communityId=${community.communityId}&newCommunity=true`);
      }
    }
  }, [communities.ids, communities.byId, submission, requestId, navigate]); 

  const onFieldChange = (event) => {
    setCommunityName(event.target.value);
  };

  const registerCommunity = (event) => {
    event.preventDefault();

    if(validator.isEmpty(communityName)) {
      setFormError('You must enter the community name');
      return;
    }

    const newRequestId = random();
    setSubmission(true);
    setRequestId(newRequestId);
    setFormError(null);
    magdalaAPI.createCommunity(newRequestId, { communityName });
  }; 

  const clearPopMessage = () => {
    setCommunitiesError(null);
  };

  return (
    <div className="CommunityRegistration">
      <FormWrapper squared={true} raised={true}>
        <h2>Register Community</h2>
        <Form id='CommunityRegistration-form' onSubmit={registerCommunity} autoComplete="off"
          submitLabel="Register" submission={submission}>
          <FormField fieldName="communityName" label="Community Name" error={formError}>
            <Input name="communityName" value={communityName} onChange={onFieldChange}
              error={validator.isDefined(formError)} />
          </FormField>
        </Form>
      </FormWrapper>
      { communitiesError !== null &&
        <PopMessage horizontal="center" open={true} onClose={clearPopMessage}
          type={stateConfig.messageTypes.ERROR}>
          <p>The registration failed with the following message: {communitiesError.code} - {communitiesError.message}</p>
        </PopMessage>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return { 
    communities: state.magdalaCommunities
  };
}

function mapDispatchToProps(dispatch) {
  return { 
    magdalaAPI: bindActionCreators(magdalaAPI, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunityRegistration);
